import React from "react";
import styled from '@emotion/styled';
import { Field } from "formik";

const Error = styled.span`
  color: red;
`;

const Input = ({ name,placeholder }) => (
  <Field name={name}>
    {({  field,form: { errors }, meta }) => (
      <div>
        <Error>{errors[name]}</Error>
        <input {...field}  placeholder={placeholder}/><br />
      </div>
    )}
  </Field>
);

export default Input;